<section class="page-intro">
  <p class="kicker">{{ lang.t('mktKicker') }}</p>
  <h1>{{ lang.t('mktTitle') }}</h1>
  <p class="lede">{{ lang.t('mktLede') }}</p>
</section>

<div class="toolbar">
  <label class="search">
    <span class="sr">{{ lang.t('mktSearch') }}</span>
    <input
      type="search"
      [attr.placeholder]="lang.t('mktPh')"
      [value]="query()"
      (input)="query.set($any($event.target).value)"
    />
  </label>
  <div class="chips" role="tablist" [attr.aria-label]="lang.t('mktClass')">
    @for (item of filters; track item.id) {
      <button type="button" [class.on]="filter() === item.id" (click)="filter.set(item.id)">{{ lang.t('class' + item.id) }}</button>
    }
  </div>
</div>

<div class="table-wrap">
  <table>
    <thead>
      <tr>
        <th>{{ lang.t('mktMarket') }}</th>
        <th>{{ lang.t('mktClassCol') }}</th>
        <th>{{ lang.t('mktTrend') }}</th>
        <th class="num">{{ lang.t('mktLast') }}</th>
        <th class="num">{{ lang.t('mktChange') }}</th>
        <th class="num">{{ lang.t('mktVolume') }}</th>
      </tr>
    </thead>
    <tbody>
      @for (quote of rows(); track quote.symbol) {
        <tr>
          <td>
            <a [routerLink]="['/trade', quote.symbol]" class="symbol-link">
              <strong>{{ quote.symbol }}</strong>
              <span>{{ quote.name }}</span>
            </a>
          </td>
          <td><span class="pill">{{ lang.t('one' + quote.assetClass) }}</span></td>
          <td><app-sparkline [points]="quote.spark" [up]="quote.changePct >= 0" [width]="104" [height]="30" /></td>
          <td class="num">{{ price(quote.price, quote.precision) }}</td>
          <td class="num" [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</td>
          <td class="num muted">{{ compact(quote.volume) }}</td>
        </tr>
      } @empty {
        <tr>
          <td colspan="6" class="empty">
            @if (market.offline()) {
              {{ lang.t('mktOffline') }}
            } @else if (market.loading()) {
              {{ lang.t('mktOpening') }}
            } @else {
              {{ lang.t('mktNone') }}
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
